// extracted by mini-css-extract-plugin
export default {"input":"phone-input_input__ofVO7","arrow":"phone-input_arrow__sYywI","diagBounce":"phone-input_diagBounce__3ZzpW"};